import * as React from "react";
const SvgWeight20Px = (props) =>
  React.createElement(
    "svg",
    Object.assign(
      {
        xmlns: "http://www.w3.org/2000/svg",
        width: 20,
        height: 20,
        fill: "black",
        viewBox: "0 0 20 20"
      },
      props
    ),
    React.createElement("path", {
      fill: "current",
      fillRule: "evenodd",
      d: "M8.25 3.75a1.75 1.75 0 1 1 3.5 0 1.75 1.75 0 0 1-3.5 0ZM10 0a3.75 3.75 0 0 0-3.173 5.75H3.698l-.174.783-2.5 11.25L.754 19h18.493l-.27-1.217-2.5-11.25-.175-.783h-3.129A3.75 3.75 0 0 0 10 0ZM3.247 17l2.055-9.25h9.396L16.753 17H3.247Z",
      clipRule: "evenodd"
    })
  );
export default SvgWeight20Px;
